function getRendimientoState(state) {
  return {
    postingLeads: state.postingStatisticsRendimiento.postingLeads,
    postingLeadsCharts: state.postingStatisticsRendimiento.postingLeadsCharts,
    loadingPostingLeads: state.postingStatisticsRendimiento.loadingPostingLeads,
    loadingCharts: state.postingStatisticsRendimiento.loadingCharts,
    hasRendimientoData: state.postingStatisticsRendimiento.hasRendimientoData,
    hasRendimientoDataCharts: state.postingStatisticsRendimiento.hasRendimientoDataCharts
  };
}

export { getRendimientoState };
